import React from 'react';
import {Input} from 'semantic-ui-react';

export const Filter = ({column}) => {
  return (
    <div>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({column,
}) => {
  return (
    <Input fluid
      value={column.filterValue || ''}
      onChange={(e) => {
        column.setFilter(e.target.value || null);
      }}
    />
  );
};

export const NonDefaultColumnFilter = ({column}) => {
  return (
    <Input fluid
      value={column.filterValue || ''}
      onChange={(e) => {
        column.setFilter(e.target.value || null);
      }}
    />
  );
};
